import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatApiError(detail) {
  if (!detail) return "Accesso non riuscito.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || "").join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, {
        email: form.email.trim().toLowerCase(),
        password: form.password,
      });
      localStorage.setItem("ascari_admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-white border border-[var(--ink)]/20 rounded-md p-3 text-sm focus:border-[var(--gold)] outline-none transition-colors";

  return (
    <section className="bg-[var(--ink)] min-h-[70vh] flex items-center py-24 px-6" data-testid="admin-login-page">
      <div className="max-w-md mx-auto w-full bg-white rounded-xl p-8 md:p-10 text-[var(--ink)]">
        <span className="font-mono-lbl text-xs uppercase tracking-widest text-[var(--gold-deep)] block mb-2">
          Area Riservata
        </span>
        <h1 className="font-display font-bold text-2xl mb-6">Accesso Agenzia</h1>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <label htmlFor="al-email" className="block font-mono-lbl text-[11px] uppercase tracking-wider mb-1">Email</label>
            <input
              id="al-email"
              data-testid="admin-login-email"
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className={inputCls}
              autoComplete="username"
            />
          </div>
          <div>
            <label htmlFor="al-pass" className="block font-mono-lbl text-[11px] uppercase tracking-wider mb-1">Password</label>
            <input
              id="al-pass"
              data-testid="admin-login-password"
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className={inputCls}
              autoComplete="current-password"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full py-3.5 bg-[var(--ink)] text-[var(--gold-light)] font-mono-lbl text-xs uppercase tracking-widest font-bold rounded hover:bg-[var(--gold)] hover:text-[var(--ink)] transition-colors disabled:opacity-60"
          >
            {loading ? "Accesso..." : "Entra"}
          </button>
        </form>
      </div>
    </section>
  );
}
